// Client mirror of functions-common/src/repeat/itemMapper.ts. Keep in sync.

import type { RepeatItemInput } from './types'

const asString = (val: unknown, fallback: string | null = null): string | null =>
  typeof val === 'string' && val.trim().length > 0 ? val.trim() : fallback

const asStringArray = (val: unknown): string[] =>
  Array.isArray(val) ? val.filter((entry): entry is string => typeof entry === 'string' && entry.length > 0) : []

export const repeatItemInputFromData = (
  id: string,
  data: Record<string, unknown> | null | undefined,
): RepeatItemInput => {
  const d = data ?? {}
  const rawBlocked = d.blockedByNodeIds
  const blockedByNodeIds = Array.isArray(rawBlocked)
    ? (rawBlocked as Array<{ targetId?: unknown } | string>)
        .map((l) => {
          if (typeof l === 'string' && l.trim().length > 0) return { targetId: l.trim() }
          if (l && typeof l === 'object' && typeof (l as { targetId?: unknown }).targetId === 'string' && ((l as { targetId: string }).targetId.trim().length > 0)) {
            return { targetId: (l as { targetId: string }).targetId.trim() }
          }
          return null
        })
        .filter((l): l is { targetId: string } => l !== null)
    : null

  return {
    id,
    title: asString(d.title),
    checklistType: asString(d.checklistType),
    nodeKind: asString(d.nodeKind),
    gateInputIds: asStringArray(d.gateInputIds),
    dependencyNodeIds: asStringArray(d.dependencyNodeIds),
    prerequisites: asStringArray(d.prerequisites),
    blockedByNodeIds,
    recurringWindow: (d.recurringWindow as RepeatItemInput['recurringWindow']) ?? null,
    repeatPaused: Boolean(d.repeatPaused),
    repeatPausedReason: asString(d.repeatPausedReason),
    notRequiredFrom: asString(d.notRequiredFrom),
    workflowStatus: asString(d.workflowStatus),
    isCompleted: Boolean(d.isCompleted),
    deletedAt: (d.deletedAt as RepeatItemInput['deletedAt']) ?? null,
    requiresProofFile: Boolean(d.requiresProofFile),
    proofFileUrl: asString(d.proofFileUrl),
    proofSubmissionId: asString(d.proofSubmissionId),
    requiresLocationPin: Boolean(d.requiresLocationPin),
    verifiedCoordinates: d.verifiedCoordinates as RepeatItemInput['verifiedCoordinates'],
    resourceGateStatus: asString(d.resourceGateStatus),
    blockedByExternal: d.blockedByExternal as RepeatItemInput['blockedByExternal'],
  }
}
